import React from "react";
import { ReactComponent as WhitePlainTick } from "../../../Assets/Icons/whiteplaintick.svg";

const SelectOption = ({ icon, title, handleClick, clicked, postIcon, greyIcon, exampleText, showCheckmark, useCustomGrey, noMargin }) => {
    // CSS filter to approximate #00ADEF on monochrome icons
    const blueFilter =
        "invert(53%) sepia(95%) saturate(2070%) hue-rotate(167deg) brightness(95%) contrast(102%)";
    // CSS filter to approximate #8C8C8C on monochrome icons
    const greyFilter = "invert(61%) sepia(0%) saturate(107%) hue-rotate(188deg) brightness(91%) contrast(84%)";

    return (
        <div
            className={`relative border ${clicked ? "border-[#00ADEF]" : "border-[#D9D9D9]"
                } rounded-[5px] h-[45px] w-full flex items-center justify-between ${noMargin ? "" : "mb-4"} cursor-pointer ${clicked ? "bg-[#EBF9FE]" : "bg-white"
                }`}
            onClick={handleClick}
        >
            <div className="flex items-center justify-start gap-3 ml-3">
                {showCheckmark && (
                    <div className="flex items-center justify-center">
                        {clicked ? (
                            <div className="w-[18px] h-[18px] sm:w-[16px] sm:h-[16px] md:w-[18px] md:h-[18px] border border-[#00ADEF] rounded-[3px] bg-[#00ADEF] flex items-center justify-center">
                                <WhitePlainTick className="w-[12px] h-[12px] sm:w-[10px] sm:h-[10px] md:w-[12px] md:h-[12px] checkmark-pop" />
                            </div>
                        ) : (
                            <div className="w-[18px] h-[18px] sm:w-[16px] sm:h-[16px] md:w-[18px] md:h-[18px] border border-[#00ADEF] rounded-[3px] bg-white" />
                        )}
                    </div>
                )}
                {icon !== null && (
                    <img
                        src={icon}
                        className={`w-[25px] h-[25px] ${greyIcon && !clicked && !useCustomGrey ? "grayscale-[1]" : ""}`}
                        style={clicked ? { filter: blueFilter } : (useCustomGrey ? { filter: greyFilter } : {})}
                    />
                )}
                <p className={`font-poppins font-[400] sm:text-[12px] md:text-[14px] leading-[21px] ${clicked ? "text-[#00ADEF]" : "text-[#303030]"
                    }`}>
                    {title}
                </p>
            </div>
            <div className="flex items-center mr-3">
                {exampleText && (
                    <p className={`font-poppins font-[400] sm:text-[12px] md:text-[14px] ${clicked ? "text-[#00ADEF]" : "text-[#767676]"}`}>
                        {exampleText}
                    </p>
                )}
                {postIcon !== null && <img src={postIcon} className="w-[70px] ml-2" />}
            </div>
        </div>
    );
};

export default SelectOption;
